<div class="min-h-screen px-8 py-8">
  <h1 class="text-primary mb-8 text-[28px] font-[700]" i18n="@@profileUpdateTitle">Update Profile</h1>

  <div class="w-full rounded-[12px] bg-white p-8 shadow-[0px_0px_12px_1px_rgba(0,0,0,0.06)]">
    <div class="mb-6 flex items-center gap-2.5">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="text-black">
        <path
          d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M18.5 2.50001C18.8978 2.10218 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10218 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10218 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="text-text-heading text-[18px] font-[600]" i18n="@@editInformation">Edit Information</span>
    </div>

    <div class="bg-border-subtle mb-8 h-[2px]"></div>

    @if (apiError()) {
      <div
        class="mb-6 flex items-center gap-2 rounded-[8px] border border-red-100 bg-red-50 px-4 py-3 text-[14px] text-red-600">
        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fill-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clip-rule="evenodd" />
        </svg>
        {{ apiError() }}
      </div>
    }

    <form [formGroup]="updateForm" (ngSubmit)="onSave()" class="space-y-6">
      <div class="grid grid-cols-1 gap-x-8 gap-y-6 md:grid-cols-2">
        <div class="flex flex-col gap-1.5">
          <label class="text-label-muted text-[14px] font-[500]" i18n="@@firstName">
            First Name
            <span class="text-red-500">*</span>
          </label>
          <input
            type="text"
            formControlName="firstName"
            class="border-border-subtle bg-input-surface focus-border-primary w-full rounded-[8px] border px-4 py-3 text-[15px] transition-all outline-none focus:bg-white"
            [class.!border-red-500]="updateForm.get('firstName')?.invalid && updateForm.get('firstName')?.touched" />
          @if (updateForm.get("firstName")?.invalid && updateForm.get("firstName")?.touched) {
            <span class="text-[12px] font-[500] text-red-600">{{ getErrorMessage("firstName") }}</span>
          }
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-label-muted text-[14px] font-[500]" i18n="@@lastName">
            Last Name
            <span class="text-red-500">*</span>
          </label>
          <input
            type="text"
            formControlName="lastName"
            class="border-border-subtle bg-input-surface focus-border-primary w-full rounded-[8px] border px-4 py-3 text-[15px] transition-all outline-none focus:bg-white"
            [class.!border-red-500]="updateForm.get('lastName')?.invalid && updateForm.get('lastName')?.touched" />
          @if (updateForm.get("lastName")?.invalid && updateForm.get("lastName")?.touched) {
            <span class="text-[12px] font-[500] text-red-600">{{ getErrorMessage("lastName") }}</span>
          }
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-label-muted text-[14px] font-[500]" i18n="@@email">Email Address</label>
          <input
            type="email"
            formControlName="email"
            class="border-border-subtle bg-input-surface focus-border-primary w-full rounded-[8px] border px-4 py-3 text-[15px] transition-all outline-none focus:bg-white"
            [class.!border-red-500]="updateForm.get('email')?.invalid && updateForm.get('email')?.touched" />
          @if (updateForm.get("email")?.invalid && updateForm.get("email")?.touched) {
            <span class="text-[12px] font-[500] text-red-600">{{ getErrorMessage("email") }}</span>
          }
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-label-muted text-[14px] font-[500]" i18n="@@gender">Gender</label>
          <select
            formControlName="gender"
            class="border-border-subtle bg-input-surface focus-border-primary w-full cursor-pointer appearance-none rounded-[8px] border px-4 py-3 text-[15px] outline-none focus:bg-white">
            <option value="M" i18n="@@male">Male</option>
            <option value="F" i18n="@@female">Female</option>
          </select>
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-label-muted text-[14px] font-[500]" i18n="@@mobile">Mobile Number</label>
          <div class="border-border-subtle bg-bg flex overflow-hidden rounded-[8px] border">
            <input
              type="text"
              formControlName="mobileNumber"
              readonly
              class="w-full cursor-not-allowed bg-transparent px-4 py-3 text-[15px] text-gray-500 outline-none" />
            <span
              class="border-border-subtle flex items-center gap-1 border-s bg-gray-100 px-3 text-[14px] text-gray-600">
              +20
              <span>🇪🇬</span>
            </span>
          </div>
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-label-muted text-[14px] font-[500]" i18n="@@birthDate">Birth Date</label>
          <input
            type="date"
            formControlName="birthDate"
            class="border-border-subtle bg-input-surface focus-border-primary w-full rounded-[8px] border px-4 py-3 text-[15px] transition-all outline-none focus:bg-white" />
        </div>
      </div>

      <div class="flex flex-row-reverse justify-start gap-4 pt-10">
        <button
          type="button"
          (click)="onCancel()"
          i18n="@@cancel"
          class="border-primary text-primary hover-bg-primary-10 cursor-pointer rounded-[8px] border px-10 py-2.5 text-[14px] font-[600] transition-all">
          Cancel
        </button>
        <button
          type="submit"
          [disabled]="loading() || !updateForm.dirty"
          class="bg-primary hover-bg-primary-hover flex cursor-pointer items-center gap-2 rounded-[8px] px-10 py-2.5 text-[14px] font-[600] text-white transition-all disabled:cursor-not-allowed disabled:opacity-50">
          @if (loading()) {
            <span class="h-4 w-4 animate-spin rounded-full border-2 border-white/30 border-t-white"></span>
          }
          <span i18n="@@saveChanges">
            {{ loading() ? (isAr ? "جاري الحفظ..." : "Saving...") : isAr ? "حفظ " : "Save" }}
          </span>
        </button>
      </div>
    </form>
  </div>
</div>
